import React, { useCallback, useEffect, useRef, useState } from "react";
import { View, ScrollView, useWindowDimensions, TouchableOpacity, Image, KeyboardAvoidingView, BackHandler, ActivityIndicator, } from "react-native";
import { appColors, appFonts, fontSize } from "../../themes/appTheme";
import { useFormik, } from "formik";
import * as Yup from 'yup';
import { useIsFocused } from "@react-navigation/native";
import { ZenButton, ZenDropdown, ZenIcon, ZenInput, ZenLoader, ZenSwitch, ZenToast, ZenText } from "zen-core-elements";
import { getScreenPermission, useAppDispatch, useAppSelector } from "../../redux/hooks";
import { addNewStaff, getOneStaffDetails, staffType, updatePin, updateStaffDetails, verifyEmail } from "../../redux/slices/staffSlice";
import base64 from "react-native-base64";
import { useAppNavigation, useAppRoute } from "../../types/@react-navigation/navigation";
import { ZenRBSheetRef } from "zen-core-elements/src/elements/zenRBSheet/RBSheet";
import Popover from "react-native-popover-view";
import CommonDialogBox from "../../shared/commonComponents/commonDialogBox";
import { DialogBoxType } from "../giftCard/giftCardModule";
import { config } from "../../shared/environment";
import { CustomModal } from "../../shared/commonComponents/customModal";
import CommonHeader from "../../shared/commonComponents/commonHeader";
import CommonImageUpload, { commonPickerRes } from "../../shared/commonComponents/commonImageUpload";
import { shallowEqual } from "react-redux";
import { ValueType } from "zen-core-elements/src/elements/zenDropdown/dropdownPicker";

export type commonType =
    {
        id: number,
        name: string
    }

const AddEditStaff = () => {
    const { isWrite: isStaffWrite } = useAppSelector(getScreenPermission("StaffStack"), shallowEqual)
    const dispatch = useAppDispatch()
    const { isWrite: isRoleWrite } = useAppSelector(getScreenPermission("RoleStack"), shallowEqual)
    const getAllLocations = useAppSelector((state) => state?.common?.getStoreLocations?.value)

    const getAllCountry = useAppSelector((state) => state?.common?.getCountry?.value)

    const userDetails = useAppSelector((state) => state?.common?.currentUser?.value)

    const rolesData = useAppSelector((state) => state?.roles?.value?.roles?.rows)

    const Route = useAppRoute('AddEditStaff')

    const [role, setRole] = useState<{ label: string, value: string }[]>([])

    const [Location, setLocation] = useState<{ label: string, value: string }[]>([])

    const [countrycode, setCountryCode] = useState<{ label: string, value: string }[]>([])

    const { width, height } = useWindowDimensions()

    const navigation = useAppNavigation()

    const [openLocation, setOpenLocation] = useState(false)
    const bottomRef = useRef<ZenRBSheetRef>(null)


    const [selectedLocation, setSelectedLocation] = useState<string[]>()

    const [open, setOpen] = useState(false)

    const [selectedValue, setSelectedValue] = useState<ValueType>('')

    const [focus, setFocus] = useState<{ [key: string]: boolean }>()

    const isFocus = useIsFocused()

    const [openCountry, setOpenCountry] = useState(false)

    const [notificationList, setNotificationList] = useState([
        {
            id: '1',
            name: 'Sms Notification',
            selected: false,
            keys: 'smsNotification'
        },
        {
            id: '2',
            name: 'Push Notification',
            selected: false,
            keys: 'pushNotification'

        },
        {
            id: '3',
            name: 'Email Notification',
            selected: false,
            keys: 'emailNotification'

        }
    ])

    const [selectedCountry, setSelectedCountry] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    const [staffDetails, setStaffDetails] = useState<staffType | null>(null)

    const [transParentLoad, setIsTransParentLoad] = useState(false)

    const [verifyExists, setIsVerifyEmail] = useState(false)

    const [verifyLoading, setIsVerifyLoading] = useState(false)

    const [confiramtionProp, setConfirmationProps] = useState<DialogBoxType | null>(null)

    const [confirmationPopover, setConfirmationPopover] = useState(false)

    const [eyeOpen, setEyeOpen] = useState(false)


    useEffect(() => {
        if (isFocus) {
            setIsLoading(true)
            setStaffDetails(null)
            if (Route?.params?.isEdit) {
                getOneStaffDetail(Route.params?.id || '')
            }
            else {
                getAllRole()
            }
        }
    }, [isFocus])

    const validationSchema = Yup.object().shape({
        isEditForm: Yup.boolean(),
        firstName: Yup.string().required('First Name is required'),
        email: Yup.string()
            .label('Email')
            .required('Email is required')
            .matches(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                'Please provide a valid email address',
            ),
        phoneNumber: Yup.string().
            required('PhoneNumber is required')
            .matches(/^\d+$/, 'Only numbers are allowed'),
        countryCode: Yup.string()
            .required('Countrycode is required'),
        password: Yup.string()
            .when('isEditForm', {
                is: false,
                then: schema => schema.required('Password is required')
                    .min(8, 'Atleast 8 characters required')
                    .matches(
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/,
                        'Must include upper, lower, number & symbol'
                    ),
                otherwise: schema => schema.notRequired()
            }),
        role: Yup.object()
            .required('Role is required')
            .test('not-empty', 'Role is reqiured', value => {
                return value && Object.keys(value).length > 0;
            }),
        location: Yup.array().
            required('Location is required')
            .min(1, 'Choose Atleast One Location'),
        dailyTarget: Yup.string().required('DailyTarget is required')
            .matches(/^\d+$/, 'Only numbers are allowed'),
        weeklyTarget: Yup.string().required('WeeklyTarget is required')
            .matches(/^\d+$/, 'Only numbers are allowed'),
        monthlyTarget: Yup.string().required('MonthlyTarget is required')
            .matches(/^\d+$/, 'Only numbers are allowed'),
        setPin: Yup.string()
            .when('isEditForm', {
                is: false,
                then: schema => schema.required('Pin is required')
                    .matches(/^\d+$/, 'Only numbers are allowed'),
                otherwise: schema => schema.notRequired()
            })
    });

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: {
            firstName: staffDetails?.firstName ? staffDetails?.firstName : '',
            email: staffDetails?.email ? staffDetails?.email : '',
            phoneNumber: staffDetails?.phone ? staffDetails?.phone : '',
            countryCode: staffDetails?.countryCode ? staffDetails?.countryCode : '',
            password: '',
            role: staffDetails?.role ? staffDetails?.role : {} as commonType,
            location: staffDetails?.userLocationsMappings ? staffDetails?.userLocationsMappings : [] as commonType[],
            dailyTarget: staffDetails?.target.dailyTarget ? String(staffDetails?.target.dailyTarget) : '',
            weeklyTarget: staffDetails?.target?.weeklyTarget ? String(staffDetails?.target?.weeklyTarget) : '',
            monthlyTarget: staffDetails?.target?.monthlyTarget ? String(staffDetails?.target?.monthlyTarget) : '',
            setPin: '',
            notification: notificationList ? notificationList : [],
            isEditForm: Route?.params?.isEdit || false,
            imageUrl: staffDetails?.imageUrl ? staffDetails?.imageUrl : ''
        },
        onSubmit: () => {
            addStaff(Route?.params?.isEdit || false)
        }
    })

    const getOneStaffDetail = async (id: string) => {
        try {
            await dispatch(getOneStaffDetails({ staffId: id })).unwrap().then((res) => {
                if (res) {
                    let addkey = { ...res }
                    addkey.userDetails.userdetails['role']['name'] = addkey?.userDetails?.userdetails?.role?.role || ''
                    setStaffDetails(addkey?.userDetails.userdetails)

                    const notifykeys = Object.fromEntries(
                        Object.entries(res.userDetails.userdetails).filter(([_, value]) => value === true)
                    );
                    let filterkeys = Object.keys(notifykeys).filter((value) => notifykeys[value])

                    setNotificationList((prev) => {
                        let updateNotification = [...prev]
                        updateNotification.map((item) => {
                            if (filterkeys.includes(item.keys)) {
                                item.selected = true
                            }
                        }
                        )
                        return updateNotification
                    })

                    getAllRole(res?.userDetails?.userdetails.userLocationsMappings, res?.userDetails?.userdetails?.role, Number(res?.userDetails.userdetails?.countryCode || 0))

                }
            }).catch((error) => {
                console.log("error in getOneStaffDetails-->", error);
            })
        }
        catch (error) {
            ZenToast({ type: 'error', message: 'Something Went Wrong' })
            navigation.goBack()
            console.log("error in getOneStaffDetail", error);
        }
    }

    //Function used to handle the image picker actions
    const handleImage = (name: string, res?: commonPickerRes[]) => {
        switch (name) {
            case 'Camera':
            case 'Library':
                if (res && res.length > 0) {
                    const data = {
                        fileName: res?.[0]?.fileName!,
                        fileUrl: res?.[0]?.originalPath!,
                        ext: res?.[0]?.fileName?.split(".")?.pop()!,
                        image: res?.[0]?.key!,
                        url: config?.AWSImageUrl + res?.[0]?.key!
                    }
                    formik?.setFieldValue('imageUrl', data)
                }
                break;
            case 'StoreImageGallery':
                if (res && res.length > 0) {
                    const data = {
                        fileName: res?.[0]?.fileName!,
                        fileUrl: res?.[0]?.originalPath!,
                        ext: res?.[0]?.fileName?.split(".")?.pop()!,
                        image: res?.[0]?.key!,
                        url: config?.AWSImageUrl + res?.[0]?.key!
                    }
                    formik?.setFieldValue('imageUrl', data)
                }
                break;
            case 'Cancel':
                break;
        }
    }

    const getAllRole = useCallback((location?: { locationId: number }[], roleId?: { id: number, role: string }, countryCode?: number) => {

        let allRoles = []
        allRoles = rolesData ? rolesData?.map((item) => {
            return {
                ...item,
                label: item?.name,
                value: item?.name
            }
        }) : []
        const data = []
        if (!allRoles?.length && isRoleWrite) {
            data.push({ label: "+ Add Roles", value: "addroles", isAdd: true })
        }
        const allRolesData = [...allRoles, ...data]
        setRole(allRolesData)
        if (roleId) {
            setSelectedValue(roleId.role)
        }
        let existLocations = [...location?.map((i) => String(i.locationId)) || []]
        let allLocations: { label: string, value: string }[] = []
        let addlocations: string[] = []
        let existCountryCode = ''
        let locationForPayload: { id: number, name: string, locationId: number }[] = []
        allLocations = getAllLocations ? getAllLocations
            .map((item) => {
                if (existLocations.includes(String(item.id))) {
                    locationForPayload.push({ id: item.id, name: item.locationName, locationId: item.id })
                    addlocations.push(item.locationName)
                }
                return {
                    ...item,
                    label: item.locationName,
                    value: item.locationName,
                }
            }) : []
        setLocation(allLocations)

        let allCountryCode: { label: string, value: string }[] = []
        allCountryCode = getAllCountry?.country ? getAllCountry?.country?.map((item) => {
            if (String(countryCode) == String(item.countryCode)) {
                existCountryCode = String(item.countryIsoCode + " " + "+" + item.countryCode)
            }
            return {
                ...item,
                label: String("+" + item.countryCode + " " + item?.name),
                value: String(item.countryIsoCode + " " + "+" + item.countryCode)
            }
        }) : []
        setCountryCode(allCountryCode)
        if (addlocations) {
            setSelectedLocation(addlocations)
        }
        if (countryCode) {
            setSelectedCountry(existCountryCode)
            setStaffDetails((prev) => {
                if (!prev) return prev
                let addkey = { ...prev }
                addkey['countryCode'] = (existCountryCode)
                addkey['userLocationsMappings'] = locationForPayload
                return addkey
            })
        }
        setIsLoading(false)
    }, [getAllLocations, rolesData, staffDetails])

    const addStaff = async (isEdit: boolean) => {
        try {
            setIsTransParentLoad(true)
            let notifyName: any =
            {
                'Push Notification': "pushNotification",
                'Email Notification': "emailNotification",
                'Sms Notification': "smsNotification",
            }
            let notificationPlugin = formik.values.notification.reduce((acc, i) => {
                const key = notifyName[i.name]; // map display name to field key
                if (key) {
                    acc[key] = i.selected; // ✅ store the result in acc
                }
                return acc;
            }, {} as { [key: string]: boolean });



            let data =
            {
                "firstName": formik.values.firstName,
                "inventoryLocations": formik.values.location ? formik.values.location.map((i) => i?.id) : [],
                "role": {
                    "id": formik.values.role.id,
                    "code": formik.values.role.name
                },
                "contactNumber": formik.values.phoneNumber,
                "countryCode": formik.values.countryCode,
                "isFromMail": null,
                "clientId": userDetails?.clientId,
                "isActive": Route.params?.isActive,
                target: {
                    "dailyTarget": Number(formik.values.dailyTarget),
                    "weeklyTarget": Number(formik.values.weeklyTarget),
                    "monthlyTarget": Number(formik.values.monthlyTarget)
                },
                // "profileImage": [formik?.values?.imageUrl],
            }
            let combinePayload = { ...data, ...notificationPlugin }

            let registration = "Basic " + base64?.encode(formik?.values?.email + ":" + formik?.values?.password)
            let pin = "Basic " + base64?.encode(formik?.values?.email + ":" + "pin:" + formik.values.setPin)
            if (isEdit) {
                await dispatch(updateStaffDetails({ staffId: staffDetails?.userId || '', data: combinePayload, storeId: config.storeId })).unwrap().then((res) => {
                    ZenToast({ type: 'success', message: 'Staff Details Updated Sucessfully' })
                    navigation.goBack()
                }).catch((error) => {

                }).finally(() => {
                    setIsTransParentLoad(false)
                })
            }
            else {
                await dispatch(addNewStaff({ data: combinePayload, registration, storeId: config.storeId, pin })).unwrap().then((res) => {
                    if (res) {
                        updateStaffPin(pin, registration)
                        ZenToast({ type: 'success', message: 'Staff Added Sucessfully' })
                        setIsTransParentLoad(false)
                    }
                }).catch((error) => {
                    console.log("error in addNewStaff -->", error);
                }).finally(() => {
                    setIsTransParentLoad(false)
                })
            }
        }
        catch (error) {
            ZenToast({ type: 'error', message: 'Something went wrong ,please try again later' })
            navigation.goBack()
            console.log("error in addStaff", error);
        }
    }

    const updateStaffPin = async (pin: string, registration: string) => {
        try {
            await dispatch(updatePin({ pin, registration: registration })).unwrap().then((res) => {
                ZenToast({ type: 'success', message: 'Staff Added Sucessfully' })
                navigation.goBack()
                setIsTransParentLoad(false)
            }).catch((error) => {
                console.log("error in updateStaffPin-->", error)
            })
        }
        catch (error) {
            console.log("error in updatePin", error);
        }
    }

    const handleVerifyEmail = async () => {
        try {
            setIsVerifyLoading(true)
            dispatch(verifyEmail({ data: { email: formik.values.email } })).unwrap().then((res) => {
                if (res) {
                    setIsVerifyEmail(res.emailExists)
                }
            }).catch((error) => {
                console.log("error in verifyEmail-->", error);
            }).finally(() => {
                setIsVerifyLoading(false)
            })
        }
        catch (error) {

        }
    }

    useEffect(() => {
        if (confiramtionProp && confiramtionProp.id) {
            setConfirmationPopover(false)
            if (confiramtionProp.id == 2) {
                navigation.goBack()
            }
            setConfirmationProps(null)
        }
    }, [confiramtionProp?.id])

    //UseEffect function which is used to perform backhandler operation
    useEffect(() => {
        BackHandler.addEventListener('hardwareBackPress', function () {
            if (formik?.dirty) {
                setConfirmationPopover(true)
            }
            else {
                navigation.goBack()
            }
            return true
        })
    }, [formik?.dirty])

    return (
        <View style={{ flex: 1, backgroundColor: appColors.light }}>
            <KeyboardAvoidingView style={{ flex: 1 }} >
                <View style={{ backgroundColor: appColors.lightBackgroundColor, flex: 1 }}>
                    <CommonHeader headerName={isStaffWrite ? Route?.params?.isEdit ? "Edit Staff" : "Add Staff" : "Staff Details"} backIcon backIconOnpress={() => {
                        if (formik.dirty) {
                            setConfirmationPopover(true)
                        }
                        else {
                            navigation.goBack()
                        }
                    }}
                        rightComponent={!isStaffWrite ? null : <ZenButton title="Save"
                            buttonStyle={{ backgroundColor: appColors?.primary, borderRadius: 10, paddingHorizontal: 12 }}
                            onPress={() => {
                                if (formik.dirty)
                                    formik.handleSubmit()
                                else
                                    ZenToast({ type: "warning", message: "No changes to save" })
                            }}
                        />}
                    />


                    {isLoading ?
                        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', alignSelf: 'center' }}>
                            <ZenLoader lottieType="Local" lottie={require("../../assets/infinityLoader.json")} />
                        </View> :
                        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom: 50 }} nestedScrollEnabled >
                            <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, marginTop: 10, padding: 10 }}>

                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <View style={{ paddingHorizontal: 10 }}>
                                        <ZenText content="Basic Details" style={{ paddingVertical: 10, }} bold color={appColors.primary} />
                                        {/* <View style={{ alignItems: 'center', paddingHorizontal: width > height ? 35 : 15, paddingVertical: 20, flexDirection: 'row', }}>
                                            <View>
                                                {formik?.values?.imageUrl?.url && isStaffWrite ? <View style={{ position: 'absolute', left: 40, top: -15 }}>
                                                    <TouchableOpacity onPress={() => { formik.setFieldValue("imageUrl", "") }}>
                                                        <ZenIcon name="close-circle" type='material-community' size={25} color={appColors.red} />
                                                    </TouchableOpacity>
                                                </View> : null}
                                                <View>
                                                    <Image style={{ borderRadius: 60 }} resizeMode="stretch" height={60} width={60} source={{ uri: formik?.values?.imageUrl?.url ? formik?.values?.imageUrl.url : formik?.values?.imageUrl ? config.AWSImageUrl + formik?.values?.imageUrl : "https://w7.pngwing.com/pngs/340/946/png-transparent-avatar-user-computer-icons-software-developer-avatar-child-face-heroes-thumbnail.png" }} />
                                                </View>
                                            </View>

                                            {isStaffWrite && <View>
                                                <ZenButton title={formik?.values?.imageUrl ? "Update Image" : "Upload Image"}
                                                    buttonStyle={{ marginHorizontal: 10, backgroundColor: appColors.light, borderColor: appColors.primary, borderWidth: 1, borderRadius: 8 }}
                                                    titleStyle={{ color: appColors.primary, fontFamily: appFonts.bold, fontSize: fontSize?.smallerFontSize }}
                                                    onPress={() => bottomRef?.current?.open()} />
                                            </View>}
                                        </View> */}
                                    </View>
                                </View>
                                {/* first name & email */}

                                <View style={{ flexDirection: width > height ? 'row' : 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10, zIndex: openCountry ? undefined : 1 }}>
                                    <View style={{ width: width > height ? '48%' : '100%' }}>
                                        <ZenInput
                                            label="First Name*"
                                            onBlur={formik.handleBlur('firstName')}
                                            containerStyle={{ width: '100%' }}
                                            disabled={!isStaffWrite}
                                            // placeholder="First Name"
                                            value={formik.values.firstName}
                                            inputContainerStyle={{ borderColor: focus?.firstName ? appColors.primary : '#D9D9D9', borderWidth: 1 }}
                                            onFocus={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['firstName'] = true
                                                    return value
                                                })
                                            }}
                                            onEndEditing={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['firstName'] = false
                                                    return value
                                                })
                                            }} onChangeText={formik.handleChange('firstName')}
                                            errorMessage={formik.touched.firstName && formik.errors.firstName ? formik.errors.firstName : undefined}
                                            errorStyle={{
                                                marginLeft: 10, color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                    formik?.errors?.firstName &&
                                                        !formik?.isValid &&
                                                        formik?.touched.firstName
                                                        ? 5
                                                        : 0,
                                            }}
                                        />
                                    </View>

                                    <View style={{ width: width > height ? '48%' : '100%' }}>
                                        <ZenInput
                                            label="Email *"
                                            disabled={!isStaffWrite}
                                            onBlur={formik.handleBlur('email')}
                                            autoCapitalize="none"
                                            // placeholder="Email"
                                            value={formik.values.email}
                                            onChangeText={formik.handleChange('email')}
                                            keyboardType="email-address"
                                            disabled={Route?.params?.isEdit}
                                            onFocus={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['email'] = true
                                                    return value
                                                })
                                            }}
                                            onEndEditing={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['email'] = false
                                                    return value
                                                })
                                                if (!formik.errors.email) {
                                                    handleVerifyEmail()
                                                }
                                            }}
                                            rightIcon={verifyLoading ? <ActivityIndicator size={'small'} color={appColors.primary} /> : undefined}
                                            errorMessage={formik.touched.email && formik.errors.email ? formik.errors.email : verifyExists ? 'Email Already Exist' : undefined}
                                            errorStyle={{
                                                marginLeft: 10, color: appColors?.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                    formik?.errors?.email &&
                                                        !formik?.isValid &&
                                                        formik?.touched.email
                                                        ? 5
                                                        : 0,
                                            }}
                                            inputContainerStyle={{ borderColor: focus?.email ? appColors.primary : '#D9D9D9', borderWidth: 1 }}
                                            containerStyle={{ width: '100%' }}
                                        />
                                    </View>
                                </View>

                                {/* Country code & Phonenumber */}

                                <View style={{ flexDirection: width > height ? 'row' : 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10, zIndex: openCountry ? undefined : 1 }}>
                                    <View style={{ width: width > height ? '48%' : '100%', alignSelf: "flex-start" }}>
                                        <ZenDropdown
                                            items={countrycode}
                                            disabled={!isStaffWrite}
                                            placeholder="Select a country code"
                                            titleStyle={{
                                                fontFamily: appFonts.medium,
                                                color: appColors.dark,
                                                fontSize: fontSize?.smallerFontSize,
                                            }}
                                            title="Country Code*"
                                            value={selectedCountry}
                                            open={openCountry}
                                            setOpen={setOpenCountry}
                                            setValue={setSelectedCountry}
                                            labelStyle={{ fontSize: fontSize.smallerFontSize, color: appColors.dark, fontFamily: appFonts.medium }}
                                            dropdownDirection='BOTTOM'
                                            maxHeight={180}
                                            placeholderStyle={{ color: appColors.grey, fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize }}
                                            multiple={false}
                                            onSelectItem={(val) => { formik.setFieldValue('countryCode', val.value) }}
                                            onPress={() => { formik.setFieldTouched('countryCode', true) }}
                                            searchable={true}
                                            listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                            style={{ borderTopWidth: 1, height: 45, borderRadius: 5 }}
                                        />
                                        {
                                            formik?.errors?.countryCode && !formik?.isValid && formik?.touched.countryCode ?
                                                <ZenText content={formik.errors.countryCode} bold size={'small'} color={appColors.red} style={{ marginLeft: 10, color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical: 5 }} /> : null
                                        }
                                    </View>

                                    <View style={{ width: width > height ? '48%' : '100%' }}>
                                        <ZenInput
                                            label={"Phone Number*"}
                                            disabled={!isStaffWrite}
                                            keyboardType='phone-pad'
                                            onBlur={formik.handleBlur('phoneNumber')}
                                            onFocus={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['phoneNumber'] = true
                                                    return value
                                                })
                                            }}
                                            onEndEditing={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['phoneNumber'] = false
                                                    return value
                                                })
                                            }}
                                            value={String(formik.values.phoneNumber)}
                                            onChangeText={formik.handleChange('phoneNumber')}
                                            errorMessage={formik.touched.phoneNumber && formik.errors.phoneNumber ? formik.errors.phoneNumber : undefined}
                                            errorStyle={{
                                                marginLeft: 10,
                                                color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                    formik?.errors?.phoneNumber &&
                                                        !formik?.isValid &&
                                                        formik?.touched.phoneNumber
                                                        ? 5
                                                        : 0,
                                            }}
                                            inputContainerStyle={{ borderColor: focus?.phoneNumber ? appColors.primary : '#D9D9D9', borderWidth: 1, }}
                                        />
                                    </View>

                                </View>
                                {/* Role & Location */}
                                <View style={{ flexDirection: width > height ? 'row' : 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10 }}>
                                    <View style={{ width: width > height ? '48%' : '100%', }}>
                                        <ZenDropdown
                                            items={role}
                                            title="Role*"
                                            disabled={!isStaffWrite}
                                            maxHeight={180}
                                            titleStyle={{
                                                fontFamily: appFonts.medium,
                                                color: appColors.dark,
                                                fontSize: fontSize?.smallerFontSize,
                                            }}
                                            value={selectedValue}
                                            placeholder="Select Role"
                                            open={open}
                                            setOpen={setOpen}
                                            setValue={() => undefined}
                                            zIndex={10}
                                            labelStyle={{ fontSize: fontSize.smallerFontSize, color: appColors.dark, fontFamily: appFonts.medium }}
                                            dropdownDirection='TOP'
                                            placeholderStyle={{ color: appColors.grey, fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize }}
                                            multiple={false}
                                            listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                            onPress={() => { formik.setFieldTouched('role', true) }}
                                            onSelectItem={(val) => {
                                                if (val?.isAdd) {
                                                    navigation.navigate('AddRole', { id: null, isEdit: false, roleName: '' })
                                                    setOpen(false);
                                                    return;
                                                }
                                                formik.setFieldValue('role', val)
                                                setSelectedValue(val?.value)
                                                setOpen(false);
                                            }}
                                            searchable={true}
                                            style={{ borderRadius: 5 }}
                                        />
                                        {
                                            formik.touched.role && formik.errors.role && typeof formik.errors.role == 'string' ?
                                                <ZenText content={formik.errors.role} bold size={'small'} color={appColors.red} style={{ marginLeft: 10, color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical: 5 }} /> : null
                                        }
                                    </View>
                                    <View style={{ width: width > height ? '48%' : '100%' }}>
                                        <ZenDropdown
                                            items={Location}
                                            disabled={!isStaffWrite}
                                            maxHeight={180}
                                            title="Location"
                                            titleStyle={{
                                                fontFamily: appFonts.medium,
                                                color: appColors.dark,
                                                fontSize: fontSize?.smallerFontSize,
                                            }}
                                            listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                            open={openLocation}
                                            setOpen={setOpenLocation}
                                            dropdownDirection="TOP"
                                            setValue={setSelectedLocation}
                                            multipleText={selectedLocation ? selectedLocation.toString() : "val"}
                                            labelStyle={{ fontSize: fontSize.smallerFontSize, color: appColors.dark, fontFamily: appFonts.medium }}
                                            placeholder={'Select a location*'}
                                            placeholderStyle={{ color: appColors.grey, fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize }}
                                            value={selectedLocation ? selectedLocation : []}
                                            multiple={true}
                                            searchable
                                            onPress={() => { formik.setFieldTouched('location', true) }}
                                            onSelectItem={(val) => {
                                                formik.setFieldValue('location', val)
                                            }}
                                            style={{ borderRadius: 5 }}
                                        />
                                        {
                                            formik.touched.location && formik.errors.location && typeof formik.errors.location == 'string' ?
                                                <ZenText content={formik.errors.location} bold size={'small'} color={appColors.red} style={{ marginLeft: 10, color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }} /> : null
                                        }
                                    </View>
                                </View>
                                {/* Password */}
                                <View style={{ paddingHorizontal: 10, marginVertical: 10 }}>

                                    {!Route.params?.isEdit && <View style={{ width: width > height ? '48%' : '100%' }}>
                                        <ZenInput
                                            label="Password *"
                                            disabled={!isStaffWrite}
                                            onBlur={formik.handleBlur('password')}
                                            value={formik.values.password}
                                            onChangeText={formik.handleChange('password')}
                                            secureTextEntry={!eyeOpen}
                                            onFocus={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['password'] = true
                                                    return value
                                                })
                                            }}
                                            onEndEditing={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['password'] = false
                                                    return value
                                                })
                                            }}
                                            rightIcon={<ZenIcon name={eyeOpen ? "eye-outline" : 'eye-off-outline'} type='material-community' size={25} onPress={() => {
                                                setEyeOpen(!eyeOpen)
                                            }
                                            } />}
                                            errorMessage={formik.touched.password && formik.errors.password ? formik.errors.password : ''}
                                            errorStyle={{
                                                marginLeft: 10, color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                    formik?.errors?.password &&
                                                        !formik?.isValid &&
                                                        formik?.touched.password
                                                        ? 5
                                                        : 0,
                                            }}
                                            inputContainerStyle={{ borderColor: focus?.password ? appColors.primary : '#D9D9D9', borderWidth: 1 }}
                                            containerStyle={{ width: '100%' }}
                                        />
                                    </View>}
                                </View>
                            </View>

                            <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, marginVertical: 10, paddingHorizontal: 10 }}>
                                <ZenText content="Target" bold style={{ paddingVertical: 10 }} color={appColors.primary} />
                                <View style={{ flexDirection: width > height ? 'row' : 'column', paddingVertical: 20, justifyContent: 'space-between', alignItems: width > height ? 'center' : undefined, width: '100%', paddingHorizontal: 10 }}>
                                    <View style={{ width: width > height ? '30%' : '100%' }}>
                                        <ZenInput
                                            label="Daily Target*"
                                            disabled={!isStaffWrite}
                                            keyboardType='number-pad'
                                            onBlur={formik.handleBlur('dailyTarget')}
                                            containerStyle={{ width: '100%' }}
                                            value={formik.values.dailyTarget}
                                            onFocus={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['dailyTarget'] = true
                                                    return value
                                                })
                                            }}
                                            onEndEditing={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['dailyTarget'] = false
                                                    return value
                                                })
                                            }}
                                            onChangeText={formik.handleChange('dailyTarget')}
                                            errorMessage={formik.touched.dailyTarget && formik.errors.dailyTarget ? formik.errors.dailyTarget : undefined}
                                            errorStyle={{
                                                marginLeft: 10, color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                    formik?.errors?.dailyTarget &&
                                                        !formik?.isValid &&
                                                        formik?.touched.dailyTarget
                                                        ? 5
                                                        : 0,
                                            }}
                                            inputContainerStyle={{ borderColor: focus?.dailyTarget ? appColors.primary : '#D9D9D9', borderWidth: 1 }}
                                        />

                                    </View>
                                    <View style={{ width: width > height ? '30%' : '100%' }}>
                                        <ZenInput
                                            label="Weekly Target*"
                                            disabled={!isStaffWrite}
                                            keyboardType='number-pad'
                                            containerStyle={{ width: '100%' }}
                                            value={formik.values.weeklyTarget}
                                            onFocus={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['weeklyTarget'] = true
                                                    return value
                                                })
                                            }}
                                            onEndEditing={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['weeklyTarget'] = false
                                                    return value
                                                })
                                            }}
                                            // placeholder="Weekly Target"
                                            onChangeText={formik.handleChange('weeklyTarget')}
                                            onBlur={formik.handleBlur('weeklyTarget')}
                                            errorMessage={formik.touched.weeklyTarget && formik.errors.weeklyTarget ? formik.errors.weeklyTarget : undefined}
                                            errorStyle={{
                                                marginLeft: 10, color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                    formik?.errors?.weeklyTarget &&
                                                        !formik?.isValid &&
                                                        formik?.touched.weeklyTarget
                                                        ? 5
                                                        : 0,
                                            }}
                                            inputContainerStyle={{ borderColor: focus?.weeklyTarget ? appColors.primary : '#D9D9D9', borderWidth: 1 }}
                                        />

                                    </View>
                                    <View style={{ width: width > height ? '30%' : '100%' }}>
                                        <ZenInput
                                            label="Monthly Target*"
                                            disabled={!isStaffWrite}
                                            keyboardType='number-pad'
                                            containerStyle={{ width: '100%' }}
                                            value={formik.values.monthlyTarget}
                                            // placeholder="Monthly Target"
                                            onFocus={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['monthlyTarget'] = true
                                                    return value
                                                })
                                            }}
                                            onEndEditing={() => {
                                                setFocus((prev) => {
                                                    let value = { ...prev }
                                                    value['monthlyTarget'] = false
                                                    return value
                                                })
                                            }}
                                            onChangeText={formik.handleChange('monthlyTarget')}
                                            onBlur={formik.handleBlur('monthlyTarget')}
                                            errorMessage={formik.touched.monthlyTarget && formik.errors.monthlyTarget ? formik.errors.monthlyTarget : undefined}
                                            errorStyle={{
                                                marginLeft: 10, color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                    formik?.errors?.monthlyTarget &&
                                                        !formik?.isValid &&
                                                        formik?.touched.monthlyTarget
                                                        ? 5
                                                        : 0,
                                            }}
                                            inputContainerStyle={{ borderColor: focus?.monthlyTarget ? appColors.primary : '#D9D9D9', borderWidth: 1 }}
                                        />

                                    </View>
                                </View>
                            </View>

                            {!Route.params?.isEdit && <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10 }}>
                                <ZenText content="Security" bold style={{ paddingVertical: 10 }} color={appColors.primary} size={'medium'} />
                                <View style={{ paddingVertical: 20, width: width > height ? '48%' : '100%' }}>
                                    <ZenInput
                                        label="Set Pin *"
                                        disabled={!isStaffWrite}
                                        containerStyle={{ width: width > height ? '55%' : '100%' }}
                                        onFocus={() => {
                                            setFocus((prev) => {
                                                let value = { ...prev }
                                                value['pin'] = true
                                                return value
                                            })
                                        }}
                                        maxLength={4}
                                        onEndEditing={() => {
                                            setFocus((prev) => {
                                                let value = { ...prev }
                                                value['pin'] = false
                                                return value
                                            })
                                        }}
                                        value={formik?.values?.setPin}
                                        keyboardType='number-pad'
                                        onChangeText={formik.handleChange('setPin')}
                                        onBlur={formik.handleBlur('setPin')}
                                        inputContainerStyle={{ borderColor: focus?.pin ? appColors.primary : '#D9D9D9', borderWidth: 1 }}
                                        errorMessage={formik.touched.setPin && formik.errors.setPin ? formik.errors.setPin : undefined}
                                        errorStyle={{
                                            marginLeft: 10, color: appColors.red, fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize, marginVertical:
                                                formik?.errors?.setPin &&
                                                    !formik?.isValid &&
                                                    formik?.touched.setPin
                                                    ? 5
                                                    : 0,
                                        }}

                                    />
                                </View>
                            </View>}

                            {/* <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, marginVertical: 10, paddingHorizontal: 10 }}>
                                <ZenText content="Notification" bold style={{ paddingVertical: 10 }} color={appColors.primary} size={'medium'} />
                                <View style={{ paddingHorizontal: width > height ? 25 : 10, paddingVertical: 20, }}>

                                    {
                                        formik.values.notification.map((val, key) =>
                                        (
                                            <View key={key} style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginVertical: 5, paddingHorizontal: 10, }}>
                                                <ZenText content={val.name} size={'small'} color={val.selected ? appColors.lightDark : appColors.grey} bold={val.selected} />
                                                <ZenSwitch
                                                    disabled={!isStaffWrite}
                                                    activeColor={appColors.primary}
                                                    activeThumbColor={appColors.lighterGrey}
                                                    inActiveColor={appColors.lightGrey}
                                                    inactiveThumbColor={appColors.lightDark}
                                                    value={val.selected}
                                                    onValueChange={() => {
                                                        let updateNotification = formik.values.notification.map((item) => {
                                                            return {
                                                                ...item,
                                                                selected: item.name == val.name ? !item.selected : item.selected
                                                            }
                                                        })
                                                        formik.setFieldValue('notification', updateNotification)
                                                    }}
                                                />
                                            </View>

                                        ))
                                    }
                                </View>
                            </View> */}

                        </ScrollView>
                    }
                </View>
            </KeyboardAvoidingView>

            <CustomModal visible={transParentLoad} transparent={true}>
                <ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={appColors?.primary} lottieType="Local" lottie={require('../../assets/infinityLoader.json')} />
            </CustomModal>

            <CommonImageUpload
                bottomRef={bottomRef}
                propFn={handleImage}
                gallery={{ isStoreGallery: false, sectionName: "blog" }}
                selectedIndex={{ value: { imagesMaxLength: 1 } }}
            />

            <Popover isVisible={confirmationPopover}>
                <CommonDialogBox type='EDIT' replaceValue="Staff" confirmation={setConfirmationProps} />
            </Popover>
        </View>
    )
}

export default AddEditStaff